<template>
    <v-menu
        :ref="`menu_${_uid}`"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        min-width="auto"
        v-model="localMenu"
    >
        <template v-slot:activator="{ on, attrs }">
            <v-text-field
                :label="label || 'Selecciona un rango de fechas'"
                prepend-icon="mdi-calendar"
                v-model="localValue"
                readonly
                v-bind="attrs"
                v-on="on"
            ></v-text-field>
        </template>
        <v-date-picker
            first-day-of-week="1"
            v-model="localValue"
            no-title
            scrollable
            range
            :type="type"
            @input="handleInput"
        >
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="clearDates"> Limpiar </v-btn>
            <v-btn text color="primary" @click="confirm"> OK </v-btn>
        </v-date-picker>
    </v-menu>
</template>

<script>
export default {
    props: {
        value: {
            type: Object,
            default: () => ({ start: null, end: null }),
        },
        label: String,
        type: String,
    },
    data() {
        return {
            localMenu: false,
            localValue: [], // Para el v-date-picker
        };
    },
    watch: {
        value: {
            handler(newVal) {
                if (newVal && newVal.start && newVal.end) {
                    this.localValue = [newVal.start, newVal.end];
                } else {
                    this.localValue = [];
                }
            },
            deep: true,
        },
    },
    computed: {
        formatDisplayValue() {
            if (!this.value || !this.value.start || !this.value.end) return "";
            return `${this.formatDate(this.value.start)} - ${this.formatDate(
                this.value.end
            )}`;
        },
    },
    methods: {
        handleInput(dates) {
            if (!dates || dates.length !== 2) return;

            // Ordenar las fechas para asegurar que start sea la menor
            const [date1, date2] = dates.sort();

            // Emitir el objeto con formato start/end
            this.$emit("input", {
                start: date1,
                end: date2,
            });

            this.localValue = dates;
        },
        clearDates() {
            this.localValue = [];
            this.$emit("input", {
                start: null,
                end: null,
            });
            this.localMenu = false;
        },
        confirm() {
            let data;
            if (this.localValue.length == 1) {
                data = {
                    start: this.localValue[0],
                    end: this.localValue[0],
                };
            } else {
                data = {
                    start: this.localValue[0],
                    end: this.localValue[1],
                };
            }
            this.$emit("input", data);
            this.localMenu = false;
        },
        formatDate(date) {
            if (!date) return "";
            const [year, month, day] = date.split("-");
            return this.type === "month"
                ? `${month}-${year}`
                : `${day}/${month}/${year}`;
        },
    },
    computed: {
        //
    },
};
</script>
